import { HttpInterceptorFn } from '@angular/common/http'
import { from } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'
import { AuthSession, fetchAuthSession } from 'aws-amplify/auth'
import { environment } from './environments/environment'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  return from(fetchAuthSession({ forceRefresh: false })).pipe(
    switchMap((session: AuthSession) => {
      // Vérifie si la session est valide

      const token = session?.tokens?.idToken?.toString()

      // Clone la requête avec les nouveaux headers
      const newReq = req.clone({
        setHeaders: {
          Authorization: token ? `${token}` : '',
          'Live-Mode': environment.production.toString(),
          program: environment.program,
        },
      })

      // Passe la requête modifiée au handler suivant
      return next(newReq)
    }),
    catchError((err) => {
      //Si soucis lors du get des tokens, on utilise juste la requête intiale
      throw err
    })
  )
}
